// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFCpsBgkumVa8MFwooWwArCDexg3VR5dg",
  authDomain: "momorox---web.firebaseapp.com",
  projectId: "momorox---web",
  storageBucket: "momorox---web.firebasestorage.app",
  messagingSenderId: "306226857714",
  appId: "1:306226857714:web:5980cb8e10bde0594cf26b",
  measurementId: "G-ST78PQRSDR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
